import { Action, Dispatch } from 'redux';
import { previewVideo, stopVideoPreview } from '../utils/videojs';
import { IVideoClip } from '../../../api/vault/clipList';
import { IAppState } from '../../../state/reducers';

export enum ActionType {
  UpdateCurrentReviewingClip = 'CurrentReviewingClip.Update',
  ResetCurrentReviewingClip = 'CurrentReviewingClip.Reset',
}

export interface ICurrentReviewingClipAction extends Action<ActionType> {
  payload?: any;
}

export interface IState {
  index: number,
  info: IVideoClip,
}

const INITIAL_STATE: IState = {
  index: null,
  info: null,
};

export default function reducer(state = INITIAL_STATE, action: ICurrentReviewingClipAction) {
  switch (action.type) {
    case ActionType.UpdateCurrentReviewingClip:
      return {
        ...state,
        ...action.payload,
      };
    case ActionType.ResetCurrentReviewingClip:
      return INITIAL_STATE;
    default:
      return state;
  }
}

const updateCurrentReviewingClip = (state: IState) => ({
  type: ActionType.UpdateCurrentReviewingClip,
  payload: state,
});

export const resetCurrentReviewingClip = () => ({
  type: ActionType.ResetCurrentReviewingClip,
});

export const previewClip = (clipIndex: number) => (
  dispatch: Dispatch<ICurrentReviewingClipAction>,
  getState: () => IAppState,
) => {
  const { clipList: { allClips } } = getState();
  if (!allClips) return;
  const clip = allClips[clipIndex];
  const { markInTime, markOutTime } = clip;

  dispatch(updateCurrentReviewingClip({ index: clipIndex, info: clip }));
  previewVideo(markInTime, markOutTime);
};

export const stopClipPreview = () => (
  dispatch: Dispatch<ICurrentReviewingClipAction>,
  getState: () => IAppState,
) => {
  dispatch(resetCurrentReviewingClip());
  stopVideoPreview();
};

export const selectIsClipReviewInProgress = (state: IAppState) => state.currentReviewingClip.index !== null;

export const selectIsClipReviewing = (state: IAppState, clipIndex: number) => state.currentReviewingClip.index === clipIndex;

export const selectCurrentReviewingClip = (state: IAppState) => state.currentReviewingClip.info;
